import PropTypes from 'prop-types';
import _get from 'lodash/get';
import parse from 'html-react-parser';

import CardModule from '../../shared/card-module';
import useProfileCommonStore from '../../../../stores/profile/use-profile-common-store';
import { className } from '../../../../utils/GlobalCssProxy';

const RisksDisclosure = props => {
  const { displayMutualFundNonPropText, riskCategories } = props;
  const { commonState } = useProfileCommonStore();
  const text = _get(commonState, 'footnotes.nonNumberedNote2');
  const riskCategoriesList = riskCategories.join(', ');

  if (!text && !displayMutualFundNonPropText) {
    return null;
  }

  return (
    <CardModule
      data-analytics-componenttype="disclaimer-text-component"
      data-analytics-id="DT_RisksDisclosures"
      data-analytics-section="component"
      {...className('bg-transparent')}
    >
      <h3 {...className('font-size-14', 'text-gray-500')}>Risks</h3>
      <p {...className('paragraph-standard', 'font-size-14', 'mb-0')}>
        {text && parse(text)}
      </p>
      {displayMutualFundNonPropText && (
        <p {...className('paragraph-standard', 'font-size-14', 'mb-0')}>
          The risks that the fund is subject to include: {riskCategoriesList}. For complete details
          about the risks associated with each product you should carefully
          review the product&apos;s most recent prospectus (located at the top of the
          page) before making an investment decision.
        </p>
      )}
    </CardModule>
  );
};

RisksDisclosure.defaultProps = {
  displayMutualFundNonPropText: false,
  riskCategories: []
};

RisksDisclosure.propTypes = {
  displayMutualFundNonPropText: PropTypes.bool,
  riskCategories: PropTypes.array
};
export default RisksDisclosure;
